import { motion } from 'framer-motion';

import { Button } from '../Button';
import { defaultMotionProps } from './motion';
import { Diamond } from './Ornaments/Diamond';
import { EllipsePurple } from './Ornaments/EllipsePurple';
import { PinkPolygon } from './Ornaments/PinkPolygon';
import { SmallCircle } from './Ornaments/SmallCircle';
import { Star } from './Ornaments/Star';
import { WhiteCircle } from './Ornaments/WhiteCircle';
import { YellowCircle } from './Ornaments/YellowCircle';

export const Footer = () => {
  return (
    <footer className="bg-cipher-04 relative overflow-hidden">
      <PinkPolygon className="absolute ml:top-90 top-20 ml:left-[10vw] left-0 ml:w-200 w-70" />
      <WhiteCircle className="absolute ml:bottom-240 ml:left-90 ml:w-80 w-20 top-20 right-40 ml:right-auto ml:top-auto" />
      <Diamond className="absolute top-10 left-[30vw] ml:w-180 w-40" />
      <EllipsePurple className="absolute ml:-top-150 -top-30 right-[20vw] xl:w-550 w-300 w-120 blur-sm" />
      <YellowCircle className="absolute ml:top-80 top-40 ml:-right-150 ml:w-360 w-80 -right-40" />
      <WhiteCircle className="absolute top-100 right-[20vw] w-70 hidden ml:block" />
      <WhiteCircle className="absolute bottom-140 right-[5vw] w-80 hidden ml:block" />
      <SmallCircle className="absolute ml:bottom-40  bottom-160 ml:right-[120px] xl:right-[15vw] -right-40 ml:w-180 w-80 ml:hidden xl:block " />
      <Star className="absolute ml:-bottom-150 bottom-120 ml:left-20 -left-60 xl:w-420 w-130 ml:w-220" />
      <div className="max-w-[700px] mx-auto px-15 ml:px-30 pt-140 ml:pt-320 ml:pb-70 pb-24 flex flex-col gap-16 ml:gap-35 text-cloud relative z-10">
        <motion.p
          className="ml:text-[36px] text-[16px] font-normal leading-[104%] tracking-[-0.36px] text-center max-w-[250px] ml:max-w-[560px] mx-auto text-pretty"
          {...defaultMotionProps}
        >
          To our Transcend customers, thank you for powering the future of
          responsible AI and growth.
        </motion.p>
        <motion.p
          className="ml:text-[22px] text-[14px] font-light leading-[125%] tracking-[-0.36px] text-center max-w-[250px] ml:max-w-[560px] mx-auto text-pretty"
          {...defaultMotionProps}
        >
          Explore the story behind Data Rights Unwrapped. Learn why we created
          it, how it’s evolved, and the incredible impact driven by our
          customers.
        </motion.p>
        <motion.div {...defaultMotionProps} className="mx-auto">
          <Button
            href="/blog/data-rights-unwrapped-2025"
            variant="primary"
            className="text-center  max-w-max ml:mb-190 mb-120"
          >
            Learn more
          </Button>
        </motion.div>
        <p className="ml:text-[12px] text-[10px] font-light leading-[128%] tracking-[-0.12px] text-center">
          <sup>&dagger;</sup>Estimated savings and hours reclaimed are based on
          modeled reductions in manual review, lookup, and multi-system data
          handling time. Estimates assume an average of 6 minutes per manual
          system lookup and standard U.S. labor rates. Calculations reflect
          internal team effort only and exclude outside legal counsel hours. All
          reported metrics are aggregated and anonymized. Actual results may
          vary based on team workflows, data ecosystem complexity, and
          implementation scope.
        </p>
      </div>
    </footer>
  );
};
